export const setPassword = {
  form: {
    email: "Email",
    error: "Set password error",
    heading: "Account",
    placeholder: "Your password here",
    submit: "Create account",
  },
  title: "Let’s finish setting up <nobr>your account</nobr>",
};
